import CONFIG from '@/config';

export default (path: string): string => {

    return CONFIG.cdnDomain + path;
};
